<template>
  <div>
    <div class="content-bottom-padded">
    <el-alert
            type="info"
            title="下载小程序连接图片： 小程序链接：必须是已经发布的小程序存在的页面（否则报错） scene最大32个可见字符，只支持数字，大小写英文以及部分特殊字符：!#$&'()*+,/:;=?@-._~，其它字符请自行编码为合法字符"
            show-icon
    ></el-alert>

      <el-select v-model="check_wxappid" @change="wxappSelectHandle" placeholder="选择小程序"
                 style="width: 50%;">
        <el-option
                v-for="(item, index) in wx_appid_list"
                :key="index"
                :label="item.name"
                :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div>
      <el-form>
        <el-form-item label="小程序链接">
          <el-input v-model="wx_url" placeholder="小程序链接"></el-input>
        </el-form-item>
        <el-form-item label="小程序scene">
          <el-input v-model="wx_scen" placeholder="小程序scene"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-col :span="3" class="content-right">
      <el-button type="primary" icon="plus" @click="handleGetQRcode">点击下载</el-button>
    </el-col>

    <router-view></router-view>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import timeChoose from '../../components/timechoose'
    import { getWxaCustomQrcode } from '../../api/wxa'

    export default {
        components: {
            timeChoose
        },
        data () {
            return {
                dialog:false,
                formLabelWidth: '120px',
                loading: false,
                check_wxappid:'',
                wx_url: '',
                wx_scen:'',
                params: {
                    'customLink': '',
                    'scene': '',
                    'wxaappid': ''
                },
                wx_appid_list:[
                    {name:'商城小程序e1b0',value:'wx47d38fb07875e1b0'},
                    {name:'多店铺商城小程序',value:'wx97aa332d3dea7ef2'}
                ],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleGetQRcode:function () {
                this.params.customLink = this.wx_url
                this.params.scene = this.wx_scen
                this.params.wxaappid = this.check_wxappid

                getWxaCustomQrcode(this.params).then(response=>{
                    var a = document.createElement('a')
                    var temp = '小程序二维码'
                    a.href = response.data.data.base64Image
                    if (response.data.data.tempname) {
                        var temp = response.data.data.tempname
                    }
                    a.download = temp  + '.png'
                    a.click()
                })
            }
        },
        mounted () {

        }
    }
</script>
<style scoped lang="scss">
  .refresh {
    color: #38f;
    cursor: pointer;
  }
  .el-button a { color: #fff; }
  .el-transfer {
    text-align: center;
    padding: 10px 0 20px;
  }
</style>
<style type="text/css" lang="scss">
  .sources-dialog {
    .el-transfer-panel {
      text-align: left;
      width: 270px;
      .el-transfer-panel__body.is-with-footer {
        box-sizing: content-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// get_qrcode.vue?d5bd720a